/**
 * API Endpoints Configuration
 * Defines all API endpoints used in the application.
 * 
 * All variable names, logs, and comments are in English.
 */

export const API_ENDPOINTS = {
  // Health check endpoint
  HEALTH: '/api/health',
  
  // Video information endpoints
  INFO: '/api/info',
  
  // Download endpoints
  DOWNLOAD: '/api/download',
  DOWNLOAD_STREAM: '/api/download/stream',
  PROXY_STREAM: '/api/proxy-stream',
  
  // Job status endpoints
  STATUS: '/api/status',
  
  // Admin endpoints
  ADMIN: {
    QUEUE_STATS: '/api/admin/queue-stats',
    JOBS: '/api/admin/jobs',
    CLEANUP: '/api/admin/cleanup',
  },
  
  // Monitor endpoints
  MONITOR: {
    OVERVIEW: '/api/monitor/overview',
    SECURITY: '/api/monitor/security',
    BANDWIDTH: '/api/monitor/bandwidth',
    CACHE: '/api/monitor/cache',
    STREAMING: '/api/monitor/streaming',
    DOWNLOADS: '/api/monitor/downloads',
  },
};

export default API_ENDPOINTS;
